































import Input from '@/components/common/Input/Input.vue';
import { isUnique } from '@/utils/array';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Object as PropType<{
        [className: string]: number;
      }>,
    },
    label: { type: String },
    isAvailable: { type: Boolean },
    labelMatchObj: {
      type: Object as PropType<{
        classes?: { [className: string]: string };
      }>,
    },
  },
  data(): {
    classList: {
      name: string;
      value: number;
    }[];
    matchList: string[];
  } {
    // TBD 결측치에 대한 고려 필요 (빈 공백값("")이 클래스로 잡힐 때)

    const classList = Object.keys(this.value).map((v) => {
      return { name: v, value: this.value[v] };
    });

    return {
      classList: classList,
      matchList: [],
    };
  },
  computed: {
    keyList: function (): string[] {
      const analysisResult =
        this.$store.getters.labelAnalysisResult[this.label];

      if (!analysisResult || !analysisResult.class_counts) return [];

      return Object.keys(analysisResult.class_counts);
    },
  },
  watch: {
    keyList: function () {
      if (this.keyList.length)
        this.matchList = Array(this.classList.length).fill(this.keyList[0]);
    },
    matchList: {
      deep: true,
      handler: function (newMatchList: string[]) {
        // (!!) 품질 목표 생성에서 결정한 클래스 명 / 비율 수정 기능은 미구현,
        //      v-model이 설정되었으나 현상황에선 자식 컴포넌트에서 수정이 발생하진 않음

        const isAvailable =
          isUnique(newMatchList) && newMatchList.every((v) => !!v);

        // 부모에게 적용 가능 여부 전달
        this.$emit('update:isAvailable', isAvailable);

        if (isAvailable) {
          // 추가 emit, 보고서에 적용 가능한 객체 (matchList를 Report Object에 넣어야 함)
          const labelMatchObj: { [className: string]: string } = {};
          for (let i = 0; i < this.classList.length; i++) {
            const cls = this.classList[i];
            labelMatchObj[cls.name] = newMatchList[i];
          }

          this.$emit('update:labelMatchObj', labelMatchObj);
        } else this.$emit('update:labelMatchObj', undefined);
      },
    },
  },
  components: { Input },
});
